export const FALLBACK_FONTS = ['Arial', 'sans-serif', 'ui-icons', 'illustrative-icons'];
//# sourceMappingURL=enum.js.map